import { createFileRoute } from '@tanstack/react-router';
import { InboxScreen } from '../features/friends/InboxScreen.tsx';

export const Route = createFileRoute('/inbox/')({ component: InboxScreen });
